// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body[data-v-27d4b4f2] {
  flex: 1;
  position: relative;
  overflow: hidden;
  background: transparent;
  display: flex;
  flex-direction: column;
}
.call-main[data-v-27d4b4f2] {
  flex: 1;
  min-width: 0;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
}
.rounded[data-v-27d4b4f2] {
  border-radius: var(--27d4b4f2-\\\$getStyles\\.callBorderRadius);
  background: var(--27d4b4f2-\\\$getStyles\\.callBackground);
}
.modal-body.paints-stage[data-v-27d4b4f2],
.video-stage.paints-stage[data-v-27d4b4f2] {
  background: var(--27d4b4f2-\\\$getStyles\\.stageBackground);
}
.video-stage[data-v-27d4b4f2] {
  width: 100%;
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.audio-host[data-v-27d4b4f2] {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/video-engine/components/video-call/VideoCallRoot.vue","webpack://./VideoCallRoot.vue"],"names":[],"mappings":"AAEA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADIA;EACE,4DAAA;EACA,uDAAA;ACDF;ADIA;;EAEE,wDAAA;ACDF;ADIA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;ACDF;ADGA;EACE,aAAA;ACAF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.modal-body {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n}\n\n.call-main {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.rounded {\n  border-radius: v-bind(\"$getStyles.callBorderRadius\");\n  background: v-bind(\"$getStyles.callBackground\");\n}\n\n.modal-body.paints-stage,\n.video-stage.paints-stage {\n  background: v-bind(\"$getStyles.stageBackground\");\n}\n\n.video-stage {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n.audio-host {\n  display: none;\n}\n",".modal-body {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n}\n\n.call-main {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.rounded {\n  border-radius: v-bind(\"$getStyles.callBorderRadius\");\n  background: v-bind(\"$getStyles.callBackground\");\n}\n\n.modal-body.paints-stage,\n.video-stage.paints-stage {\n  background: v-bind(\"$getStyles.stageBackground\");\n}\n\n.video-stage {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.audio-host {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
